module.exports = function() {
  return new Worker(__webpack_public_path__ + "1ebc561886cab8f6f4bb.worker.js");
};